import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import seedreamImage from "@/assets/agent/seedream@3x.webp";

export const SeedreamImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[seedreamImage]}
      {...props}
    />
  );
};

SeedreamImage.displayName = 'SeedreamImage';
